import React from "react";
// elementos de joy material para el modal
import Divider from "@mui/joy/Divider";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import DialogActions from "@mui/joy/DialogActions";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import Button from "@mui/joy/Button";

// icons
import FestivalIcon from "@mui/icons-material/Festival";

// componente card
import CardModal from "../../Cards/CardModal/CardModal";
import CardModalSkeleton from "../../Cards/CardSkeleton/CardSkeleton";

const ModalAreaSelect = ({
  elementos,
  openModal,
  setOpenModal,
  handleSaveElemento,
  loading,
  handleClick,
  selectedIndex,
  titulo,
}) => {
  const handleSave = async () => {
    handleSaveElemento();
  };

  return (
    <>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <ModalDialog
          variant="outlined"
          role="alertdialog"
          className="w-full max-w-lg md:max-w-xl lg:max-w-2xl mx-auto"
        >
          <DialogTitle>
            <FestivalIcon />
            Seleccionar {titulo}
          </DialogTitle>
          <Divider />
          <DialogContent>
            <List className="overflow-y-auto max-h-60vh -mx-4 px-4">
              {loading
                ? [...Array(10)].map((item, index) => (
                    <ListItem key={index}>
                      <CardModalSkeleton />
                    </ListItem>
                  ))
                : elementos.map((item, index) => (
                    <ListItem
                      key={index}
                      onClick={() => handleClick(item, index)}
                      className={`hover:bg-gray-200 ${
                        selectedIndex === index
                          ? "bg-gray-400"
                          : "bg-transparent"
                      }`}
                    >
                      <CardModal
                        image_path={
                          titulo === "Evento" ? item.logo : item.image_path
                        }
                        title={item.name}
                      ></CardModal>
                    </ListItem>
                  ))}
            </List>
          </DialogContent>
          <DialogActions>
            <Button variant="solid" color="primary" onClick={handleSave}>
              Guardar
            </Button>
            <Button
              variant="plain"
              color="neutral"
              onClick={() => setOpenModal(false)}
            >
              Cancelar
            </Button>
          </DialogActions>
        </ModalDialog>
      </Modal>
    </>
  );
};

export default ModalAreaSelect;
